const appConst = {
  ME_NAME: 'MotionElements', // do not seperate two words
  ME_TOKEN: 'ME_jwt',
  ME_TOKEN_SIG: 'ME_jwt_sig',
  ME_CURRENCY: 'ME_currency',
  ME_LANG: 'ME_lang',
  ME_PARTNER: 'ME_partner',
  ME_BETA_MODE: 'ME_SITE_BETA_MODE',
  XSRF_TOKEN: 'XSRF-TOKEN',
  DEFAULT_USD: 'USD',
  DEFAULT_USD_SYMBOL: 'US$',
  PASSWORD_MIN_LENGTH: 5,
  PASSWORD_MAX_LENGTH: 72,
  ARTIST_MEDIA_TYPES: ['video', 'music', 'sfx', 'image', '3d', 'lottie', 'graphic_template', 'image_prompt', 'ae', 'pr', 'fcp', 'resolve', 'ui_template', 'presentation_template', 'notion_template'],
  AI_CONTRIBUTOR_MEDIA_TYPES: ['video', 'image', 'music', 'sfx', '3d', 'lottie', 'prompt'],
  BUYER_MEDIA_TYPES: ['ae', 'pr', 'motion_template', '3d_model', 'lottie', 'sfx', 'video', 'music', 'image'],
  AE_SUB_MEDIA_TYPES: ['ae_preset', 'ae_template'],
  PR_SUB_MEDIA_TYPES: ['pr_preset', 'pr_template'],
  VIDEO_SUB_MEDIA_TYPES: ['video_live', 'video_vr'],
  OTHER_MEDIA_TYPES: ['animation', 'mg_template', 'photo_vr', 'gif', 'vector'],
};

export default appConst;
